import React, { FunctionComponent } from 'react'
import EasySoftwareEditorContainer from 'Root/Shared/components/EasySoftwareEditorContainer/EasySoftwareEditorContainer'
import { PuxWysiwygHtmlBodyType } from 'Shared/components/PuxWysiwyg/PuxWysiwyg'

import PuxPicture, {
  MediaSelectorImageType,
} from '../content/mediaImage/PuxPicture'
import PuxButton, { PuxButtonType } from '../PuxButton/PuxButton'

export interface EasySoftwareCardItemType {
  contentItemId: string
  contentType: string
  displayText: string
  cardItemPerex: PuxWysiwygHtmlBodyType
  cardItemImage?: MediaSelectorImageType
  cardButtonPrimary?: PuxButtonType
  cardButtonSecondary?: PuxButtonType
}

export interface EasySoftwareCardItemProps {
  data: EasySoftwareCardItemType
  pageContentItemId: string
  editorPath: string
}

const EasySoftwareCardItem: FunctionComponent<EasySoftwareCardItemProps> = (
  props
) => {
  const primaryButton = props.data.cardButtonPrimary
  const primaryButtonText = primaryButton?.buttonLink?.text?.[0]
  const image = props.data.cardItemImage
  const hasMedia = !!(
    image?.resizePaths?.find((path) => path) ||
    image?.resizePathsFallback?.find((path) => path)
  )
  const classes = [`CardItem`]

  if (!hasMedia) {
    classes.push(`CardItem--noMedia`)
  }

  if (!primaryButtonText) {
    classes.push(`CardItem--noButton`)
  }

  return (
    <div className={classes.join(` `)}>
      {hasMedia && image && (
        <div className='CardItem-media'>
          <PuxPicture {...image} width={164} height={164} />
        </div>
      )}

      <div className='CardItem-content'>
        <h4 className='CardItem-title'>{props.data.displayText}</h4>

        <div className='CardItem-perex'>
          <EasySoftwareEditorContainer
            pageContentItemId={props.pageContentItemId}
            content={props.data.cardItemPerex}
            editorPath={props.editorPath}
            wysiwygId={props.data.contentItemId}
          />
        </div>

        {primaryButton && primaryButtonText && (
          <div className='CardItem-buttons'>
            <PuxButton {...primaryButton} />
          </div>
        )}
      </div>
    </div>
  )
}

export default EasySoftwareCardItem
